import apiClient from '../client';
import type { Announcement, CreateAnnouncementPayload, UpdateAnnouncementPayload } from '@/types';

const BASE = '/admin/announcements';

export const announcementsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient
      .get<{ data: Announcement[]; pagination: { total: number } }>(BASE, { params })
      .then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: Announcement }>(`${BASE}/${id}`).then((r) => r.data.data),

  create: (payload: CreateAnnouncementPayload) =>
    apiClient.post<{ data: Announcement }>(BASE, payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateAnnouncementPayload) =>
    apiClient.put<{ data: Announcement }>(`${BASE}/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`${BASE}/${id}`),

  /**
   * Upload an image file and receive back its public Google Drive CDN URL.
   * Call this before create/update when the user selects a new image,
   * then pass the returned `image_url` in the JSON payload.
   */
  uploadImage: (file: File): Promise<string> => {
    const form = new FormData();
    form.append('image', file);
    return apiClient
      .post<{ data: { image_url: string } }>(`${BASE}/upload-image`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data.data.image_url);
  },
};

